import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section className="py-12 md:py-14 bg-white" data-id="element-324">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-325">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-326">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-navy mb-10 text-center leading-tight" data-id="element-327">
            Esa pesadez no es tu culpa.{' '}
            <span className="text-brand-gold" data-id="element-328">
              Pero te está robando la vida.
            </span>
          </h2>

          {/* 2pm scene — anchored moment */}
          <div className="relative bg-brand-cream/60 border-l-4 border-brand-gold rounded-r-xl p-6 sm:p-8 mb-10" data-id="element-329">
            <div className="flex items-baseline gap-3 mb-4" data-id="element-330">
              <span className="font-serif text-2xl sm:text-3xl font-bold text-brand-gold" data-id="element-331">
                2:00 PM
              </span>
              <span className="text-sm text-brand-navy/60 italic" data-id="element-332">
                Una escena que conoces demasiado bien.
              </span>
            </div>
            <p className="text-lg sm:text-xl text-brand-navy leading-relaxed font-medium mb-3" data-id="element-333">
              Acabas de almorzar algo relativamente normal —{' '}
              <span className="italic" data-id="element-334">arroz, pollo, ensalada.</span>
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-335">
              Y ahí está de nuevo. Esa presión en el abdomen. Esa sensación de
              que la ropa aprieta. Ese cansancio que no debería estar ahí a esta
              hora.
            </p>
          </div>

          <div className="space-y-6 text-gray-700 leading-relaxed text-base sm:text-lg" data-id="element-336">
            <p data-id="element-337">
              Has intentado dejar el pan. Has tomado batidos verdes que saben a
              pasto. Has pasado horas en el gimnasio sin que la{' '}
              <span className="italic" data-id="element-338">guatita</span> ceda.
            </p>

            <p className="text-xl text-brand-navy font-semibold leading-snug" data-id="element-339">
              Esa hinchazón no solo afecta cómo te ves en el espejo.
            </p>

            <p data-id="element-340">
              Te quita la energía para rendir en el trabajo. Te hace evitar ropa
              que antes te encantaba. Te deja sintiéndote{' '}
              <span className="font-semibold text-brand-navy" data-id="element-341">
                pesada, lenta y frustrada
              </span>{' '}
              porque parece que nada de lo que haces funciona.
            </p>

            <p className="border-t border-brand-navy/10 pt-6 text-brand-navy/80 italic" data-id="element-342">
              Y lo peor es que no sabes exactamente por qué. Porque nadie te lo
              ha explicado en términos reales.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}